import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

import { Skeleton } from 'base-ui'

export const ProductCrossSellBuyTogetherTitle: FC<PropsWithChildren> = ({
  children,
}) => {
  const Component = children ? 'h2' : Skeleton

  return (
    <Component
      className={clsx(
        'mb-3.5 text-xl font-medium tablet:text-2xl',
        !children && 'w-1/2',
      )}
    >
      {children}
    </Component>
  )
}
